import React, { useState } from 'react'
import { Button, Flex, Input, useToast } from '@chakra-ui/react'
import { CheckIcon } from '@chakra-ui/icons'
import ScoreService from '../../API/ScoreService'
import { useScoreStore } from '../../store/scoreStore'

function CollectingScoresParentPhone({scoreData}) {
    const toast = useToast()
    const [phone, setPhone] = useState(scoreData?.parent_phone || '')
    const [isLoading, setIsLoading] = useState(false)
    const updateParentPhone = useScoreStore(state => state.updateParentPhone)

    const saveParentPhone = () => {
        setIsLoading(true)
        toast.promise(
            ScoreService.updateParentPhone(scoreData.site_id, phone),
            {
                success: () => {
                    updateParentPhone(scoreData.site_id, phone)
                    setIsLoading(false)
                    return { title: "Телефон родителя обновлен" }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: "Не удалось обновить телефон родителя" }
                },
                loading: { title: "Обновление телефона родителя...", position: 'top' }
            }
        )
    }

    return (
        <Flex gap='6px'>
            <Input
                size='xs'
                minW='100px'
                type='number'
                value={phone}
                onChange={e => setPhone(e.target.value)}
            />
            <Button
                size='xs'
                disabled={!phone || isLoading || scoreData.parent_phone === phone || phone.length !== 11}
                onClick={saveParentPhone}
            >
                <CheckIcon />
            </Button>
        </Flex>
    )
}

export default CollectingScoresParentPhone
